// extracted by mini-css-extract-plugin
module.exports = {"Container":"PaymentTermsUpdate_Container__2t6jK"};